<template>
    <div class="top">
        <div class="checklist-top"
             v-bind:class="{ 'checklist-top-active': mazlicekJmeno.valid, 'checklist-top-noactive': !mazlicekJmeno.valid }">
            <div class="checklist-jmeno" v-if="mazlicekJmeno.valid">{{ mazlicekJmeno.value }}</div>
            <div class="checklist-rasa" v-if="mazlicekRasa.typ === 'app_rasa'">{{ mazlicekRasa.autocomplete.keyword
                }}
            </div>
            <div class="checklist-rasa" v-else-if="mazlicekRasa.typ === 'app_velikost' && velikost && velikost.title !== null">
                {{ velikost.title }}
            </div>
            <div class="checklist-foto" v-if="showPhoto">
                <img :src="mazlicek.fotografie.icnValue"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {apiSilex} from '../api'

    export default {
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                rasa: null,
                velikost: null
            }
        },
        computed: {
            showPhoto() {
              return this.mazlicek.fotografie.icnValue &&
                  (this.mazlicek.step.current !== 9 || (this.mazlicek.step.current === 9 && !this.isFirstOrder))
            },
            isFirstOrder () {
              return this.mazlicek.orderData.isFirstOrder
            },
            mazlicekJmeno() {
                return this.mazlicek.jmeno
            },
            mazlicekRasa() {
                return this.mazlicek.rasa
            },
            mazlicekFoto() {
                return this.mazlicek.fotografie.icnValue
            }
        },
        methods: {
            loadSize() {
                let _then = this
                apiSilex.get('/velikost').then(
                    response => {
                        _then.velikost = response.data.filter(
                            item => item.id === _then.mazlicek.rasa.velikost
                        )[0]
                    }
                )
            }
        },
        mounted: function () {
            this.loadSize()
        },
        watch: {
            'mazlicek.rasa': {
                deep: true,
                handler: function (val) {
                    this.rasa = val
                    this.loadSize()
                }
            },
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (this.mazlicek.petLoaded.value) this.loadSize()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// RightContentHeader.vue?59e04291